import {
    AppointmentsModel
} from "one-card-appointments-table";

import {
    AppointmentData
} from 'one-model-local'
import { formatIso, getday } from 'one-util-date';

/**
 * This Function transforms the backend response
 * in the Data Model that supports the 
 * Appointments Component
 * @param response has the backend 
 * appointment response
 * @param context has settings etc..
 */
//ADPAC-426
function sortFunction(a: AppointmentData, b: AppointmentData) {
    const dateA = new Date(a.date).getTime();
    const dateB = new Date(b.date).getTime();
    return dateA > dateB ? 1 : -1;
}

export const TransformResponse = (response: any, context: any, patientId: string) => {
    /**
     * @param result contains the transformed response
     */
    let result: AppointmentsModel = {};
    let dataarray: any = [];
    const { settings } = context ? context:"";
    const {uisettings:{dateformat},athenannoshowid: {id}} = settings ? settings:{uisettings:""};
    const { settings:{appointment_config:{filterAppointments}}} = context;
    let noshowcodearray:any = id;
    if (response && response.length > 0) {
        response.map((ele: any, index:number) => {
            if(ele?.appointments?.length > 0) {
                ele.appointments.map((appele: any, index:number)=>{
                    let presentdate: number = new Date().getTime();
                    let ddate: string = appele.date ? appele.date : "";
                    let dtime: string = appele.starttime ? appele.starttime : "";
                    let apptdate: number = new Date(ddate.concat(" ").concat(dtime)).getTime();
                    let data: AppointmentData = {
                        key: "",
                        date: "",
                        department: "",
                        departmentId: "",
                        appointmentTime: "",
                        provider: "",
                        providerId: "",
                        status: "",
                        visitType: "",
                        visitTypeID: "",
                        appointmentType: "",
                        appointmentDuration: "",
                        patientId: "",
                        patientName: "",
                        patientIDType: "",
                        contactID: "",
                        contactIDType: "",
                        day: "",
                        apptID:"",
                        appointmentcancelreasonid:"",
                        departmentname:"",
                        providername:""
                    };
                    data.key = index.toString();
                    if (presentdate <= apptdate &&  (appele.appointmentstatus !== "x") ){
                        data.appointmentType = "future";
                    }
                    else if (presentdate > apptdate && (appele.appointmentstatus !== "x") ) {
                        data.appointmentType = "past";
                    }
                    else if(noshowcodearray.includes(appele.appointmentcancelreasonid)) {
                        data.appointmentType = "noshows"
                    }
                    else if(appele.appointmentstatus === "x") {
                        data.appointmentType = "canceled";
                    }
                    data.date = appele.date ? formatIso(appele.date,dateformat) : "";
                    data.day = appele.date ? getday(appele.date) : "";
                    data.status = appele.appointmentstatus ? appele.appointmentstatus : "";
                    data.visitType = appele.patientappointmenttypename ? appele.patientappointmenttypename : "";
                    data.appointmentTime = appele.starttime ? appele.starttime : "";
                    data.patientId = patientId ? patientId:"";
                    data.patientIDType = context?.settings?.epicendpoints?.searchID ? context.settings.epicendpoints.searchID:"";
                    data.patientName = appele.PatientName ? appele.PatientName:"";//To be confirmed
                    data.appointmentDuration = appele.duration ? appele.duration:"";
                    data.department = appele.DepartmentName ? appele.DepartmentName:""// To be confirrmed
                    data.departmentId = appele.departmentid? appele.departmentid:"";
                    data.provider = appele.ProviderName ? appele.ProviderName : "";//To be confirmed
                    data.providerId = appele.providerid? appele.providerid:"";
                    data.apptID = appele.appointmentid ? appele.appointmentid :  "";
                    data.departmentname=appele?.departmentname?appele?.departmentname:appele?.departmentid;
                    data.providername=appele?.providername?appele?.providername:appele?.providerid
                    data.appointmentcancelreasonid=appele.appointmentcancelreasonid?appele.appointmentcancelreasonid:""
                    if(appele.ContactIDs && appele.ContactIDs.length > 0){
                        data.contactID = appele.ContactIDs[0]?.ID ? appele.ContactIDs[0].ID:"";
                        data.contactIDType = appele.ContactIDs[0]?.Type ? appele.ContactIDs[0].Type:"";
                    }//to be cofirmed
                    if(appele.VisitTypeIDs && appele.VisitTypeIDs.length > 0){
                        if(filterAppointments["athena"][2]["configuredVisitId"].length>0){
                            let keys=filterAppointments["athena"][2]["configuredVisitId"]
                            let values=ele.VisitTypeIDs.length>0?ele.VisitTypeIDs:[]
                            if(values.length>0){
                                for(var i=0;i<values.length;i++){
                                    if(keys.includes(values[i].ID.trim())){
                                        data.visitTypeID= values[i].ID
                                        break;
                                    }
                                }
                            }
                        }
                        else{
                        data.visitTypeID = appele.VisitTypeIDs[0]?.ID ? appele.VisitTypeIDs[0].ID:"";
                        }
                    }//to be confirmed
                    dataarray.push(data);
                    //ADPAC-426
                    dataarray.sort(sortFunction);
                })
            }
        });
        result['data'] = dataarray;
    }
    return result;


}